import * as z from 'zod/v4';
import { validationSchema } from '../../types';

export const userRoles = ['admin', 'viewer_only', 'qa'] as const;

export const loginBodySchema = z.union([
  z.object({
    email: z.email(),
    password: z.string(),
  }),
  z.object({
    code: z.string(),
    state: z.string(),
    codeVerifier: z.string(),
  }),
]);

export const userSchema = z.object({
  email: z.email(),
  name: z.string(),
  role: z.enum(userRoles),
  id: z.uuid(),
});

const successResponseSchema = z.object({
  accessToken: z.string(),
  user: userSchema,
});

export const loginSchema = validationSchema({
  response: {
    200: successResponseSchema,
    403: z.object({
      errorMessage: z.string(),
    }),
    401: z.object({
      errorMessage: z.string(),
    }),
  },
  body: loginBodySchema,
});

export const getMeSchema = validationSchema({
  response: {
    200: z.object({
      user: userSchema,
      accessToken: z.string(),
    }),
    500: z.object({
      errorMessage: z.string(),
    }),
  },
});

export const createUserSchema = validationSchema({
  body: z.object({
    name: z.string(),
    email: z.email(),
    role: z.enum(userRoles),
  }),
  response: {
    201: z.object({
      user: userSchema,
    }),
    500: z.object({
      errorMessage: z.string(),
    }),
  },
});

export const updateUserSchema = validationSchema({
  params: z.object({
    id: z.uuid(),
  }),
  body: z.object({
    name: z.string().optional(),
    email: z.email().optional(),
    role: z.enum(userRoles).optional(),
  }),
  response: {
    200: z.object({
      user: userSchema,
    }),
    500: z.object({
      errorMessage: z.string(),
    }),
  },
});

export const getUsersSchema = validationSchema({
  querystring: z.object({
    search: z.string().optional(),
    page: z.coerce.number().optional(),
    pageSize: z.coerce.number().optional(),
  }),
  response: {
    200: z.object({
      users: z.array(userSchema),
      total: z.number(),
      totalPages: z.number(),
    }),
    500: z.object({
      errorMessage: z.string(),
    }),
  },
});

export const deleteUserSchema = validationSchema({
  params: z.object({
    id: z.uuid(),
  }),
  response: {
    204: z.void(),
    500: z.object({
      errorMessage: z.string(),
    }),
  },
});

export const getUserSchema = validationSchema({
  params: z.object({
    id: z.uuid(),
  }),
  response: {
    200: z.object({
      user: userSchema,
    }),
    404: z.object({
      errorMessage: z.string(),
    }),
    500: z.object({
      errorMessage: z.string(),
    }),
  },
});
